
import { createSlice } from "@reduxjs/toolkit";
import { feedbackGet } from "reduxStore/actions/feedback";

const initialState = {
    userLoading: false,  // Keep this consistent with your component
    feedback: [],
    error: null
}

const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
       
    },
    extraReducers: builder => {
        builder
        .addCase(feedbackGet.pending, (state) => {
            state.userLoading = true; 
            state.error = null;
        })
        .addCase(feedbackGet.fulfilled, (state, action) => {
            state.userLoading = false;  
            if (action.payload?.success && action.payload?.data?.rows) {
                state.feedback = action.payload.data.rows;
            } else {
                state.error = action.payload?.message || "Failed to fetch Feedbacks";
            }
        })
        .addCase(feedbackGet.rejected, (state, action) => {
            console.error("Error fetching Feedbacks:", action.error.message);
            state.userLoading = false;  
            state.error = action.error.message;
        });
    }
});

export default feedbackSlice.reducer;